/**
 * @generated SignedSource<<be3e02d9802e133d6fa9013ccd00a6b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CaseAgencyModalDeleteMutation$variables = {
  id: string;
};
export type CaseAgencyModalDeleteMutation$data = {
  readonly softDelete: {
    readonly success: boolean | null;
  } | null;
};
export type CaseAgencyModalDeleteMutation = {
  response: CaseAgencyModalDeleteMutation$data;
  variables: CaseAgencyModalDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SoftDelete",
    "kind": "LinkedField",
    "name": "softDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CaseAgencyModalDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CaseAgencyModalDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a3c06f267dffa17815369b8817ee42cd",
    "id": null,
    "metadata": {},
    "name": "CaseAgencyModalDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CaseAgencyModalDeleteMutation(\n  $id: ID!\n) {\n  softDelete(id: $id) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f0921fa37ad30679f8e9df5bf141786";

export default node;
